module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', _vm._b({
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, 'el-row', _vm.$props, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24f433c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/row/rtRow.vue
// module id = 2037
// module chunks = 228